import { render, staticRenderFns } from "./Kalustonhuolto.vue?vue&type=template&id=247fea29&scoped=true"
import script from "./Kalustonhuolto.vue?vue&type=script&lang=js"
export * from "./Kalustonhuolto.vue?vue&type=script&lang=js"
import style0 from "./Kalustonhuolto.vue?vue&type=style&index=0&id=247fea29&prod&lang=scss&scoped=true"
import style1 from "./Kalustonhuolto.vue?vue&type=style&index=1&id=247fea29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247fea29",
  null
  
)

export default component.exports